module.exports = __webpack_public_path__ + "static/media/Micro.0d4f3535.png";